import React, { useEffect, useReducer, useMemo } from 'react';
import AppRoutes from '../src/routers/AppRoutes';
import theme from './themeConfig';
import { ThemeProvider } from '@material-ui/core/styles';
import UserState from './context/Globales/UserState';
import ErrorBoundary from './Error/ErrorBoundary';
import { AuthContext } from './context/Globales/AuthContext';
import { authReducer } from './context/Globales/authReducer';
import { Box, Card, CardContent, Divider } from '@material-ui/core';


function App() {
  const [StateBrowser, setStateBrowser] = React.useState(null);

  const { detect } = require('detect-browser');
  const browser = detect();

  // handle the case where we don't detect the browser

  var init = () => {
    return JSON.parse(localStorage.getItem('user')) ||
    {
      logged: false,


    }

  }


  var initSkl = () => {
    return JSON.parse(localStorage.getItem('skll')) ||
    {
      logged: false,
      skll: null

    }



  };
  // cada vez que el usuario cambie, grabamelo en el storage
  const [user, dispatch] = useReducer(authReducer, {}, init)
  const [skll] = useReducer(authReducer, {}, initSkl)


  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user));
  }, [user])

  useEffect(() => {
    localStorage.setItem('sklll', JSON.stringify(skll));
  }, [skll])


  useMemo(() => {
    switch (browser && browser.name) {
      case 'Internet Explore':
      case 'IE':
      case 'msie':
        setStateBrowser('not supported');
        break;
      default:
      //  console.log('kinda ok',browser);
        setStateBrowser('supported');
      // console.log('not supported');
    }
  }, [])

  return (
    <>
      {StateBrowser == 'supported' ?
        <AuthContext.Provider value={{
          user,
          skll,
          dispatch
        }} >

          <ErrorBoundary>
            <UserState>
              <ThemeProvider theme={theme} >
                <AppRoutes />
              </ThemeProvider>
            </UserState>
          </ErrorBoundary>
        </AuthContext.Provider>
        :
        <Box my={15} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', width: '60%' }} >
          <Card style={{ backgroundColor: '#ffffff' }} elevation={8}>
            <CardContent>
              <h1>ATENCIÓN</h1>
              <img src={process.env.PUBLIC_URL + '/static/imagen/algo-ha-salido-mal.png'} width="30%" title="Imagen algo a salido mal" alt="algo a salido mal" ></img>
              <br />
              Hemos detectado que está usando una versión de Internet Explorer que no es compatible con nuestro nuevo sitio web
              Para acceder al sitio utiliza una versión actualizada de alguno de los siguientes navegadores:<br />
              <img src={process.env.PUBLIC_URL + '/static/imagen/navegadores.png'} title="Imagen algo a salido mal" alt="algo a salido mal" width="250px" ></img>


              <Divider />
              <p></p>
              {/* <p>{this.state.message}</p> */}


            </CardContent>


          </Card>

        </Box>
      }
    </>

  );
}

export default App;
